var _document$currentScri;
var publicPath = (_document$currentScri = document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src.replace(/^(.*\/)[^/]+$/, '$1');
export function getPublicPath() {
  return publicPath || '';
}